import React, { useRef, useEffect, useState } from 'react';
import { withResizeDetector } from 'react-resize-detector';
import { makeStyles } from '@material-ui/core/styles';
import LayoutFormat from "../Layout/LayoutFormat";
import ImageBase from "./ImageBase";
const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  debug: {
    position: "absolute",
    bottom: 0
  }
}));

const ImagePreview = ({
  className,
  overflow = "hidden",
  width,
  height,
  imageUrl,
  imageCropdata = undefined,
  imageFilters = undefined
}) => {
  const classes = useStyles();
  return React.createElement(ImageBase, {
    className: className || classes.root,
    imageUrl: imageUrl,
    imageCropdata: imageCropdata,
    imageFilters: imageFilters
  });
};

export default withResizeDetector(ImagePreview);